module.exports = __webpack_public_path__ + "img/team.701edafd.svg";